module.exports = __webpack_public_path__ + "img/designBanner.00eb57f3.jpg";